// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"5fc0179c","312":"5608b1aa","433":"a6570dd7","453":"5e3c638b","806":"d064287e"}[chunkId] + ".chunk.js";
};